import { render, staticRenderFns } from "./xinzangwuyou-list.vue?vue&type=template&id=5707b1ef"
import script from "./xinzangwuyou-list.vue?vue&type=script&lang=ts"
export * from "./xinzangwuyou-list.vue?vue&type=script&lang=ts"
import style0 from "./xinzangwuyou-list.vue?vue&type=style&index=0&id=5707b1ef&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports